import { BaseEventProps } from "../../types";

export type EventProps = BaseEventProps;

export enum MediatorEventType {
  UNDO = "BETSLIP:UNDO"
}
